module.exports = __webpack_public_path__ + "assets/3f7023143948795fef96d96a889c085c.png";